import React from "react";
import { Button } from "antd";
import { ClearOutlined } from "@ant-design/icons";

// Shared "Clear Filters" control for every filter bar in the admin (Signage
// TVs, Screens, Library, Playlists, Locations, Brands, Inventory, Logs,
// Device Errors, Meeting Room Devices, Dashboard) - a plain default <Button>
// here looked identical to the filter dropdowns next to it, so as an inline
// flex item with nothing pushing it aside it could end up wrapping to a
// stray spot mid-row instead of reading as its own action. Dashed style +
// icon gives it a distinct "reset" affordance. Push it to the end of its
// filter bar by giving ITS WRAPPING Form.Item/div `style={{ marginLeft:
// "auto" }}` at each call site - that's the actual flex item in these
// inline-flex-wrap filter bars, not this button itself.
const ClearFiltersButton = ({ onClick, ...rest }) => (
  <Button type="dashed" icon={<ClearOutlined />} onClick={onClick} {...rest}>
    Clear Filters
  </Button>
);

export default ClearFiltersButton;
